const STORAGE_KEY = 'quickProductQueue:v1';

const keyFor = (row) =>
  String(row?.partNumber || row?.productNumber || '')
    .toUpperCase()
    .replace(/[\s\-_.]/g, '');

export const readLocalQuickProducts = () => {
  try {
    const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(items) ? items : [];
  } catch {
    return [];
  }
};

// Keeps a browser-local copy as a fallback when the dashboard is temporarily
// connected to an older server that does not yet expose the queue endpoints.
export const saveLocalQuickProducts = (items) => {
  const existing = new Map(readLocalQuickProducts().map((item) => [keyFor(item.row), item]));
  const now = new Date().toISOString();

  items.forEach((item) => {
    const key = keyFor(item.row);
    if (!key) return;
    existing.set(key, {
      ...existing.get(key),
      ...item,
      _id: `local-${key}`,
      status: 'PENDING',
      fetchedAt: now,
    });
  });

  const next = [...existing.values()];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
};

export const markLocalQuickProductsUploaded = (ids) => {
  const wanted = new Set(ids);
  const next = readLocalQuickProducts().map((item) =>
    wanted.has(item._id) ? { ...item, status: 'UPLOADED', uploadedAt: new Date().toISOString() } : item
  );
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
};

export const removeLocalQuickProduct = (id, row) => {
  const rowKey = keyFor(row);
  const next = readLocalQuickProducts().filter((item) => item._id !== id && (!rowKey || keyFor(item.row) !== rowKey));
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
};
